module.exports = __webpack_public_path__ + "media/music/bells_8-813e0256.mp3";